export const featureflagsLinkProperties = {
  uri: "https://www.braze.com",
};
